module.exports = __webpack_public_path__ + "static/media/baseball_icon-01.56a679d0.png";